import Obstacle from '../classes/Obstacle'
import GameElement, { GameElementType } from '../GameElement/GameElement'

const GameObstacle = (props: GameElementType) => {
  return <GameElement elementClass={Obstacle} {...props} />
}

export default GameObstacle
